/**
 * Service-worker registration for the PWA (add-to-home-screen + offline shell).
 *
 * Kept out of `main.tsx` so it stays a one-liner side effect. Registration is
 * deliberately skipped in dev: a caching SW fights Vite's HMR.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    const swUrl = new URL('sw.js', document.baseURI).href;
    navigator.serviceWorker.register(swUrl).catch((err) => {
      console.warn('[lableforge] service worker registration failed', err);
    });
  });
}
